import {
  Token_ANY_getInstance9xysfu27e7k6 as Token_ANY_getInstance,
  Token_BOOLEAN_getInstance1wgqdwqznzt13 as Token_BOOLEAN_getInstance,
  Token_STRING_getInstance470sjyvft5q9 as Token_STRING_getInstance,
  Token_NUMBER_getInstancevca4d508ugjn as Token_NUMBER_getInstance,
  Token_LONG_getInstance2zqadaqyxtu82 as Token_LONG_getInstance,
  Token_BEGIN_OBJECT_getInstance3tyutof7o1m8y as Token_BEGIN_OBJECT_getInstance,
  Token_BEGIN_ARRAY_getInstance177lhv8laq3oc as Token_BEGIN_ARRAY_getInstance,
  Token_NULL_getInstancepc9ujj0oty64 as Token_NULL_getInstance,
  Token_END_DOCUMENT_getInstance2id197vicmeuj as Token_END_DOCUMENT_getInstance,
  Token_END_OBJECT_getInstance2ogiuwolu9z45 as Token_END_OBJECT_getInstance,
  Token_END_ARRAY_getInstance2ak1vc2v5jwfi as Token_END_ARRAY_getInstance,
  Token_NAME_getInstance4fu13sk4ahsk as Token_NAME_getInstance,
} from './JsonReader.mjs';
import { JsonNumber2j5ykr5cbjkre as JsonNumber } from './JsonNumber.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  Entry2xmjmyutzoq3p as Entry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  copyOf3rutauicler23 as copyOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { readAny17j2jqaxubdko as readAny } from './JsonReaders.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { JsonDataException2rdtm884tky1l as JsonDataException } from '../../exception/Exceptions.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toDouble1kn912gjoizjp as toDouble,
  toInt2q8uldh7sc951 as toInt,
  toLongkk4waq8msp1k as toLong,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  toDoubleExact18clzpruqqw2d as toDoubleExact,
  toIntExact1n46an7ryabg9 as toIntExact,
  toIntExact1p16u7ro59o31 as toIntExact_0,
  toLongExact9cht6g9si07j as toLongExact,
} from './internal/Utils.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function anyToToken($this, any) {
  var tmp;
  if (any == null) {
    tmp = Token_NULL_getInstance();
  } else {
    if (isInterface(any, KtList())) {
      tmp = Token_BEGIN_ARRAY_getInstance();
    } else {
      if (isInterface(any, KtMap())) {
        tmp = Token_BEGIN_OBJECT_getInstance();
      } else {
        if (typeof any === 'number') {
          tmp = Token_NUMBER_getInstance();
        } else {
          if (typeof any === 'bigint') {
            tmp = Token_LONG_getInstance();
          } else {
            if (typeof any === 'number') {
              tmp = Token_NUMBER_getInstance();
            } else {
              if (any instanceof JsonNumber()) {
                tmp = Token_NUMBER_getInstance();
              } else {
                if (typeof any === 'string') {
                  tmp = Token_STRING_getInstance();
                } else {
                  if (typeof any === 'boolean') {
                    tmp = Token_BOOLEAN_getInstance();
                  } else {
                    tmp = Token_ANY_getInstance();
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function advanceIterator($this) {
  if ($this.i41_1 === 0) {
    $this.c41_1 = Token_END_DOCUMENT_getInstance();
    return Unit_instance;
  }
  var currentIterator = ensureNotNull($this.g41_1[$this.i41_1 - 1 | 0]);
  var tmp = $this.e41_1[$this.i41_1 - 1 | 0];
  if (!(tmp == null) ? typeof tmp === 'number' : false) {
    var tmp_0 = $this.e41_1;
    var tmp_1 = $this.i41_1 - 1 | 0;
    var tmp_2 = $this.e41_1[$this.i41_1 - 1 | 0];
    tmp_0[tmp_1] = ((!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE()) + 1 | 0;
  }
  if (currentIterator.q1()) {
    var next = currentIterator.r1();
    $this.d41_1 = next;
    var tmp_3 = $this;
    var tmp_4;
    if (!(next == null) ? isInterface(next, Entry()) : false) {
      tmp_4 = Token_NAME_getInstance();
    } else {
      tmp_4 = anyToToken($this, next);
    }
    tmp_3.c41_1 = tmp_4;
  } else {
    var tmp_5 = $this;
    var tmp_6;
    var tmp_7 = $this.e41_1[$this.i41_1 - 1 | 0];
    if (!(tmp_7 == null) ? typeof tmp_7 === 'number' : false) {
      tmp_6 = Token_END_ARRAY_getInstance();
    } else {
      tmp_6 = Token_END_OBJECT_getInstance();
    }
    tmp_5.c41_1 = tmp_6;
  }
}
function increaseStack($this) {
  if ($this.i41_1 === $this.e41_1.length) {
    $this.e41_1 = copyOf($this.e41_1, imul($this.e41_1.length, 2));
    $this.f41_1 = copyOf($this.f41_1, imul($this.f41_1.length, 2));
    $this.h41_1 = copyOf_0($this.h41_1, imul($this.h41_1.length, 2));
    $this.g41_1 = copyOf($this.g41_1, imul($this.g41_1.length, 2));
  }
  $this.i41_1 = $this.i41_1 + 1 | 0;
}
function findName($this, needle, haystack) {
  var expectedIndex = $this.h41_1[$this.i41_1 - 1 | 0];
  if (expectedIndex < haystack.q2() && haystack.r2(expectedIndex) === needle) {
    $this.h41_1[$this.i41_1 - 1 | 0] = $this.h41_1[$this.i41_1 - 1 | 0] + 1 | 0;
    return expectedIndex;
  } else {
    var index = haystack.r4(needle);
    if (!(index === -1)) {
      $this.h41_1[$this.i41_1 - 1 | 0] = index + 1 | 0;
    }
    return index;
  }
}
function getPathAsString($this) {
  return joinToString($this.d2t(), '.');
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      q41(_this__u8e3s4) {
        if (_this__u8e3s4 instanceof MapJsonReader())
          return _this__u8e3s4;
        var token = _this__u8e3s4.u40();
        // Inline function 'kotlin.check' call
        if (!token.equals(Token_BEGIN_OBJECT_getInstance())) {
          var message = 'Failed to buffer json reader, expected `BEGIN_OBJECT` but found `' + token.toString() + '` json token';
          throw IllegalStateException().o(toString(message));
        }
        var pathRoot = _this__u8e3s4.d2t();
        var tmp = readAny(_this__u8e3s4);
        var data = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
        return new (MapJsonReader())(data, pathRoot);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var MapJsonReaderClass;
function MapJsonReader() {
  if (MapJsonReaderClass === VOID) {
    class $ {
      constructor(root, pathRoot) {
        pathRoot = pathRoot === VOID ? emptyList() : pathRoot;
        this.a41_1 = root;
        this.b41_1 = pathRoot;
        this.d41_1 = null;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp.e41_1 = Array(64);
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp_0.f41_1 = Array(64);
        var tmp_1 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp_1.g41_1 = Array(64);
        this.h41_1 = new Int32Array(64);
        this.i41_1 = 0;
        this.c41_1 = anyToToken(this, this.a41_1);
        this.d41_1 = this.a41_1;
      }
      w41() {
        // Inline function 'kotlin.apply' call
        if (!this.u40().equals(Token_BEGIN_ARRAY_getInstance())) {
          throw JsonDataException().z47('Expected BEGIN_ARRAY but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.d41_1;
        var currentValue = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : THROW_CCE();
        increaseStack(this);
        this.e41_1[this.i41_1 - 1 | 0] = -1;
        this.g41_1[this.i41_1 - 1 | 0] = currentValue.p1();
        advanceIterator(this);
        return this;
      }
      x41() {
        // Inline function 'kotlin.apply' call
        if (!this.u40().equals(Token_END_ARRAY_getInstance())) {
          throw JsonDataException().z47('Expected END_ARRAY but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        this.i41_1 = this.i41_1 - 1 | 0;
        this.g41_1[this.i41_1] = null;
        this.e41_1[this.i41_1] = null;
        advanceIterator(this);
        return this;
      }
      r41() {
        // Inline function 'kotlin.apply' call
        if (!this.u40().equals(Token_BEGIN_OBJECT_getInstance())) {
          throw JsonDataException().z47('Expected BEGIN_OBJECT but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        increaseStack(this);
        var tmp = this.f41_1;
        var tmp_0 = this.i41_1 - 1 | 0;
        var tmp_1 = this.d41_1;
        tmp[tmp_0] = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE();
        this.j4d();
        return this;
      }
      s41() {
        // Inline function 'kotlin.apply' call
        this.i41_1 = this.i41_1 - 1 | 0;
        this.g41_1[this.i41_1] = null;
        this.e41_1[this.i41_1] = null;
        this.f41_1[this.i41_1] = null;
        advanceIterator(this);
        return this;
      }
      q1() {
        switch (this.u40().w1_1) {
          case 3:
            return false;
          case 1:
            return false;
          default:
            return true;
        }
      }
      u40() {
        return this.c41_1;
      }
      t41() {
        if (!this.u40().equals(Token_NAME_getInstance())) {
          throw JsonDataException().z47('Expected NAME but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.d41_1;
        var data = (!(tmp == null) ? isInterface(tmp, Entry()) : false) ? tmp : THROW_CCE();
        this.e41_1[this.i41_1 - 1 | 0] = data.m3();
        this.d41_1 = data.n3();
        this.c41_1 = anyToToken(this, data.n3());
        return data.m3();
      }
      b42() {
        var value = this.d41_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value.toString();
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = value.toString();
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = value.toString();
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = value;
              } else {
                if (value == null) {
                  tmp = 'null';
                } else {
                  if (value instanceof JsonNumber()) {
                    tmp = value.k4b_1;
                  } else {
                    // Inline function 'kotlin.error' call
                    var message = 'Expected a String but got ' + toString(value) + ' instead';
                    throw IllegalStateException().o(toString(message));
                  }
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      ko() {
        if (!this.u40().equals(Token_BOOLEAN_getInstance())) {
          throw JsonDataException().z47('Expected BOOLEAN but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.d41_1;
        // Inline function 'kotlin.also' call
        var this_0 = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
        advanceIterator(this);
        return this_0;
      }
      n4a() {
        if (!this.u40().equals(Token_NULL_getInstance())) {
          throw JsonDataException().z47('Expected NULL but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        advanceIterator(this);
        return null;
      }
      g42() {
        switch (this.u40().w1_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().z47('Expected a Double but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.d41_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value;
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = toDoubleExact(value);
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = value;
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toDouble(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toDouble(value.k4b_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected a Double but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      kk() {
        switch (this.u40().w1_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().z47('Expected an Int but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.d41_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value;
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = toIntExact_0(value);
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = toIntExact(value);
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toInt(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toInt(value.k4b_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected an Int but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      ho() {
        switch (this.u40().w1_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().z47('Expected a Long but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.d41_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = fromInt(value);
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = value;
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = toLongExact(value);
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toLong(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toLong(value.k4b_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected Int but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      h4d() {
        switch (this.u40().w1_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().z47('Expected a Number but was ' + this.u40().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.d41_1;
        var tmp;
        var tmp_0;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp_0 = true;
        } else {
          var tmp_1;
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp_1 = true;
          } else {
            tmp_1 = !(value == null) ? typeof value === 'number' : false;
          }
          tmp_0 = tmp_1;
        }
        if (tmp_0) {
          tmp = new (JsonNumber())(toString(value));
        } else {
          if (!(value == null) ? typeof value === 'string' : false) {
            tmp = new (JsonNumber())(value);
          } else {
            if (value instanceof JsonNumber()) {
              tmp = value;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Expected JsonNumber but got ' + toString_0(value) + ' instead';
              throw IllegalStateException().o(toString(message));
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      j41() {
        var tmp0_elvis_lhs = this.d41_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw JsonDataException().z47('Expected a non-null value at path ' + getPathAsString(this));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var data = tmp;
        // Inline function 'kotlin.also' call
        advanceIterator(this);
        return data;
      }
      t40() {
        advanceIterator(this);
      }
      l6() {
      }
      i4d(names) {
        while (this.q1()) {
          var name = this.t41();
          var index = findName(this, name, names);
          if (!(index === -1)) {
            return index;
          }
          this.t40();
        }
        return -1;
      }
      j4d() {
        var container = this.f41_1[this.i41_1 - 1 | 0];
        this.e41_1[this.i41_1 - 1 | 0] = null;
        var tmp = this.g41_1;
        var tmp_0 = this.i41_1 - 1 | 0;
        // Inline function 'kotlin.collections.iterator' call
        tmp[tmp_0] = ensureNotNull(container).l3().p1();
        this.h41_1[this.i41_1 - 1 | 0] = 0;
        advanceIterator(this);
      }
      d2t() {
        // Inline function 'kotlin.collections.mutableListOf' call
        var result = ArrayList().p2();
        result.u2(this.b41_1);
        var inductionVariable = 0;
        var last = this.i41_1;
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0_safe_receiver = this.e41_1[index];
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              result.i2(tmp0_safe_receiver);
            }
          }
           while (inductionVariable < last);
        return result;
      }
    }
    initMetadataForClass($, 'MapJsonReader');
    MapJsonReaderClass = $;
  }
  return MapJsonReaderClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  MapJsonReader as MapJsonReader2b7ri7r44421y,
  Companion_instance as Companion_instance2qv9j5e9f102y,
};
//endregion

//# sourceMappingURL=MapJsonReader.mjs.map
